import type { DocumentCopyTypeOptionModel } from '../models/dto/document-copy-config.dto';
import { CopyDocumentType } from '../models/entity';

/**
 * PD-15003 — the customer-facing documents that can carry configured copies,
 * in the order the settings screen shows them.
 *
 * Deliberately a short explicit list rather than every value of
 * CopyDocumentType: each entry needs wording that says what the document IS to
 * a customer, and adding a new document is a code change anyway (a send path
 * has to resolve recipients). Labels are English; wrap with t() in the UI.
 */
export const DOCUMENT_COPY_TYPES: ReadonlyArray<DocumentCopyTypeOptionModel> = [
	{
		value: CopyDocumentType.INVOICE,
		label: 'Invoice',
		description:
			'Sent when someone emails an invoice to a customer from the invoice screen. Anyone typed into the send dialog by hand is copied as well as the people configured here.',
	},
	{
		value: CopyDocumentType.DELIVERY_RECEIPT,
		label: 'Delivery Receipt',
		description:
			'Sent automatically when a delivery is completed. It carries the invoice PDF, so anyone copied here has already received that invoice and is not copied again if it is later emailed by hand.',
	},
	{
		value: CopyDocumentType.CREDIT_MEMO,
		label: 'Credit Memo',
		description:
			'Sent when someone emails a credit memo to a customer. When nothing is configured here, the Invoice recipients are copied instead, so credits follow invoices unless a tenant deliberately routes them differently.',
	},
];
